import { StocktakeReportModel } from './../models/dms/reportParameter.model';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppHeaderEnum, CarCheckPageHeaderEnum, DmsPageHeaderEnum, SecurityRight, VehicleXchangePageHeaderEnum, WebsiteAdminPageHeaderEnum } from 'app/utility/enums';
import { AppPageGroupModel } from 'app/models/shared/appPage.model';
import { Constants } from 'app/utility/constants';
import { WholesaleCountsModel } from 'app/models/wholesale/wholesaleCounts.model';
import { StringHelper } from 'app/utility/stringhelper';
import { ListItemModel } from 'app/models/shared/listItem.model';
import { StorageService } from 'app/services/storage.service';

export type MenuAreaType = '' | 'login' | 'dms' | 'wholesale' | 'carcheck' | 'autoattendant' | 'buyerscore' | 'financecentral' | 'adconnect' | 'ampd' | 'website-admin';

export type CountMessageEndpointType =
    'WholesaleCounts/Offers/Outgoing/PendingAcceptance' |
    'WholesaleCounts/Offers/Outgoing/SellerAccepted' |
    'WholesaleCounts/Offers/Outgoing/SellerRejected' |
    'WholesaleCounts/Offers/Incoming/PendingAcceptance' |
    'WholesaleCounts/Offers/Incoming/SellerAccepted' |
    'WholesaleCounts/Offers/Incoming/SellerRejected' |
    'WholesaleCounts/UnansweredQuestions' |
    'WholesaleCounts/Vehicles/Shortlist' |
    'WholesaleCounts/Vehicles/Selling' |
    'WholesaleCounts/Vehicles/Recommended' |
    'WholesaleCounts/Vehicles/All';

@Injectable({
    providedIn: 'root'
})
export class MenuService
{
    areaSubject: BehaviorSubject<MenuAreaType> = new BehaviorSubject("dms");
    embeddedSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    overrideArea: MenuAreaType;
    constructor(
        private storage: StorageService
    )
    {
        var overrideClientID = localStorage.getItem(Constants.LocalStorage_OverrideClientID);
        if (overrideClientID && overrideClientID != '')
        {
            this.menuTitle = "";
        }
    }

    private menuSpinnerMapSubject = new BehaviorSubject<Record<string, boolean>>({});
    public menuSpinnerMap$ = this.menuSpinnerMapSubject.asObservable();

    private menuStatusIconMapSubject = new BehaviorSubject<Record<string, { icon: string; color?: string }>>({});
    public menuStatusIconMap$ = this.menuStatusIconMapSubject.asObservable();

    public setMenuItemSpinner(url: string, spinning: boolean)
    {
        const current = { ...this.menuSpinnerMapSubject.value };
        if (spinning) current[url] = true; else delete current[url];
        this.menuSpinnerMapSubject.next(current);
    }

    public setMenuItemStatusIcon(url: string, icon: string | null, color: string = 'primary')
    {
        const current = { ...this.menuStatusIconMapSubject.value };
        if (icon) current[url] = { icon, color }; else delete current[url];
        this.menuStatusIconMapSubject.next(current);
    }

    public clearMenuItemState(url: string)
    {
        this.setMenuItemSpinner(url, false);
        this.setMenuItemStatusIcon(url, null);
    }

    public area: MenuAreaType;
    public previousArea: MenuAreaType;
    public async setArea(value: MenuAreaType)
    {
        if (this.area != value)
        {
            this.previousArea = (this.area) ? this.area : "dms";
            this.area = value;
            this.setAreaTitle();
            this.areaSubject.next(value);
        }
    }

    public menuTitle: string = "Motorcentral DMS";
    public menuPrefix: string = "";
    public menuSuffix: string = "";
    private setAreaTitle(area: MenuAreaType = null)
    {
        if (!area)
        {
            area = this.area;
        }
        this.menuTitle = "";
        this.menuPrefix = "";
        this.menuSuffix = "";
        switch (area)
        {
            case "wholesale":
                this.menuTitle = "";
                this.menuPrefix = "Vehicle";
                this.menuSuffix = "Xchange";
                break;
            case "buyerscore":
                this.menuTitle = "";
                this.menuPrefix = "Buyer";
                this.menuSuffix = "Score";
                break;
            case "autoattendant":
                this.menuTitle = "";
                this.menuPrefix = "Auto ";
                this.menuSuffix = "Attendant";
                break;
            case "carcheck":
                this.menuTitle = "";
                this.menuPrefix = "Car ";
                this.menuSuffix = "Check";
                break;
            case "financecentral":
                this.menuTitle = "";
                this.menuPrefix = "Avanti ";
                this.menuSuffix = "Finance";
                break;
            case "website-admin":
                this.menuTitle = "";
                this.menuPrefix = "Website ";
                this.menuSuffix = "Admin";
                break;
            case "dms":
            default:
                this.menuTitle = "";
                this.menuPrefix = "Motorcentral ";
                this.menuSuffix = "DMS";
                break;
        }
    }
    public async GetAppPageGroups(area: MenuAreaType, rights: SecurityRight[], extendedRights: SecurityRight[]): Promise<AppPageGroupModel[]>
    {
        var appPageGroups: AppPageGroupModel[] = [];


        var appPageGroupDms: AppPageGroupModel =
        {
            area: "dms",
            name: "",
            pages: []
        };

        if (this.mcMinVersion("3.2.18", true))
        {
            appPageGroupDms.pages.push(
                {
                    title: 'Dashboard',
                    url: '/dashboard',
                    icon: 'speedometer'
                }
            );
        }

        var stocktakeOnly = (!this.hasRight(rights, SecurityRight.VehiclesTabsGeneralView) && this.hasRight(rights, SecurityRight.ToolsVehicleStocktakeTool));

		if (!stocktakeOnly) {
			appPageGroupDms.pages.push(
				{
					title: 'Vehicles',
					url: '/vehicles',					
					iconalt: 'icon-mc-vehicle'
				}
			);
		}
		if (this.hasRight(rights, SecurityRight.OpportTabs))
		{
			appPageGroupDms.pages.push(
				{
					title: 'Opportunities',
					url: '/opportunities',
					iconalt: 'icon-mc-opportunities'
				}
			);
		}
		if (this.hasRight(rights, SecurityRight.ContactTabs))
		{
			appPageGroupDms.pages.push(
				{
					title: 'Contacts',
					url: '/contacts',
					iconalt: 'icon-mc-contacts'
				}
			);
		}
		if (this.hasRight(rights, SecurityRight.SaleTabs))
		{
			appPageGroupDms.pages.push(
				{
					title: 'Sales',
					url: '/sales',
					iconalt: 'icon-mc-sales'
				}
			);
		}
		if (this.hasRight(rights, SecurityRight.ToolsDataExport))
		{
			appPageGroupDms.pages.push(
				{
					title: 'Exports',
					url: '/exports',
					iconalt: 'icon-mc-exports'
				}
			);
		}
		if (this.hasRight(rights, SecurityRight.Reports))
		{
            const spinnerMap = this.menuSpinnerMapSubject.value;
            const iconMap = this.menuStatusIconMapSubject.value;
			appPageGroupDms.pages.push(
				{
					title: 'Reports',
					url: '/reports',
					icon: 'document',
					iconalt: 'icon-mc-reports',
                    spinner: !!spinnerMap['/reports'],
                    statusIcon: iconMap['/reports']?.icon,
                    statusIconColor: iconMap['/reports']?.color
				}
			);
		}
		if (this.mcMinVersion("3.2.21"))
        {
            const toolChildren = [
            ];


            if (this.hasRight(rights, SecurityRight.ToolsTasks))
            {
                toolChildren.push(
                    {
                        title: 'Tasks',
                        url: '/tools/tasks',
                    },
                    {
                        title: 'Reminders',
                        url: '',
                        clickEvent: 'reminders',
                        remindersBadge: true
                    }
                );
            }

            if (this.hasRight(rights, SecurityRight.ToolsDocuments))
            {
                toolChildren.push(
                    {
                        title: 'Documents',
                        url: '/tools/dealership-documents',
                    }
                );
            }

            if (this.mcMinVersion("3.2.22"))
            {
                if (this.hasRight(rights, SecurityRight.ToolsMoneyOutstanding))
                {
                    toolChildren.push(
                        {
                            title: 'Money outstanding',
                            url: '/tools/money-outstanding',
                        }
                    );
                }
                    
                if (this.hasRight(rights, SecurityRight.ToolsEventViewer))
                {
                    toolChildren.push(
                        {
                            title: 'System events',
                            url: '/tools/system-events',
                        }
                    );
                }

                if (this.mcMinVersion("3.2.26") && this.hasRight(rights, SecurityRight.AccountingRunExport))
                {
                    toolChildren.push(
                        {
                            title: 'Run export',
                            url: '/tools/run-export',
                        }
                    );
                }
                
                if (this.mcMinVersion("3.2.23") && this.hasRight(rights, SecurityRight.ToolsBulkUpdate))
                {
                    toolChildren.push(
                        {
                            title: 'Bulk update',
                            url: '/tools/bulk-update',
                        }
                    );
                }
            }

            if (this.hasRight(rights, SecurityRight.Tools) && toolChildren.length > 0)
            {
                appPageGroupDms.pages.push(
                    {
                        title: 'Tools',
                        url: '/tools',
                        icon: 'hammer',
                        subMenuOpen: false,
                        children: toolChildren,
                    }
                );
            }
        }

        if (this.mcMinVersion("3.2.22"))
        {
            const accountingChildren = [
            ];

            if (this.hasRight(rights, SecurityRight.AccountingPurchaseOrders))
            {
                accountingChildren.push(
                    {
                        title: 'Purchase orders',
                        url: '/accounting/purchase-orders',
                    }
                );
            }

            if (this.mcMinVersion("3.2.23") && this.hasRight(rights, SecurityRight.AccountingSaleInvoices))
            {
                //Shane doesnt want this in the app yet
                // accountingChildren.push(
                //     {
                //         title: 'Product sale invoices',
                //         url: '/accounting/product-sale-invoices',
                //     }
                // );
            }

            if (this.hasRight(rights, SecurityRight.Accounting) && accountingChildren.length > 0)
            {
                appPageGroupDms.pages.push(
                    {
                        title: 'Accounting',
                        url: '/accounting',
                        icon: 'file-tray-full',
                        subMenuOpen: false,
                        children: accountingChildren,
                    }
                );
            }
        } 

        if (stocktakeOnly)
        {
            appPageGroupDms.pages.push(
                {
                    title: 'Vehicle stocktake',
                    url: '/barcode',
                    iconalt: 'icon-mc-barcode',
                }
            );
        }
        // if (localStorage.getItem(Constants.LocalStorage_Updates) == "1")
        // {
        // 	appPageGroupDms.pages.push(
        // 		{F
        // 			title: 'Update App',
        // 			url: '/about',
        // 			icon: 'speedometer'
        // 		}
        // 	);
        // }
        appPageGroups.push(appPageGroupDms);

        //Car Check
        var appPageGroupCarcheck: AppPageGroupModel =
        {
            area: 'carcheck',
            name: "",
            pages: []
        };
        appPageGroupCarcheck.pages.push(
            {
                title: 'Recent checks',
                url: '/carcheck/recent',
                iconalt: 'icon-mc-check'
            }
        );
        appPageGroupCarcheck.pages.push(
            {
                title: 'Search',
                url: '/carcheck/search',
                iconalt: 'icon-mc-search',
            }
        );
        appPageGroups.push(appPageGroupCarcheck);

        //Auto Attendant
        var appPageGroupAutoAttendant: AppPageGroupModel =
        {
            area: 'autoattendant',
            name: "Auto Attendant",
            pages: []
        };
        appPageGroupAutoAttendant.pages.push(
            {
                title: 'Auto Attendant',
                url: '/autoattendant',
                iconalt: 'icon-mc-search'
            }
        );
        appPageGroups.push(appPageGroupAutoAttendant);

        //BuyerScore
        var appPageGroupBuyerScore: AppPageGroupModel =
        {
            area: 'buyerscore',
            name: "BuyerScore",
            pages: []
        };
        appPageGroupBuyerScore.pages.push(
            {
                title: 'BuyerScore',
                url: '/buyerscore',
                iconalt: 'icon-mc-search'
            }
        );
        appPageGroups.push(appPageGroupBuyerScore);

        if (this.hasRight(extendedRights, SecurityRight.ToolsDealerzoneWholesaleBuying) &&
            this.hasRight(rights, SecurityRight.ToolsDealerzoneWholesale))
        {
            //Wholesale
            var appPageGroupWholesale: AppPageGroupModel =
            {
                area: 'wholesale',
                name: "Buy",
                pages: []
            };
            // appPageGroupWholesale.pages.push(
            // 	{
            // 		title: 'My Recommendations',
            // 		url: '/wholesale/recommendations',
            // 		icon: 'heart-outline',
            // 		count: 'WholesaleCounts/Vehicles/Recommendations'
            // 	}
            // );
            appPageGroupWholesale.pages.push(
                {
                    title: 'Browse/search',
                    url: '/wholesale/vehicles',
                    iconalt: 'icon-mc-search',
                }
            );
            // appPageGroupWholesale.pages.push(
            // 	{
            // 		title: 'Browse / search',
            // 		url: '/wholesale/vehicles/search',
            // 		icon: '',
            // 		child: true
            // 	}
            // );
            // appPageGroupWholesale.pages.push(
            // 	{
            // 		title: 'Recently added',
            // 		url: '/wholesale/vehicles/view/recently-added',
            // 		icon: 'flash', //thumbs-up-outline',
            // 		child: true,
            // 	}
            // );
            appPageGroupWholesale.pages.push(
                {
                    title: 'Suggested',
                    url: '/wholesale/vehicles-suggested',
                    iconalt: 'icon-mc-recommended',
                    count: 'WholesaleCounts/Vehicles/Recommended',
                    // child: true,
                }
            );
            appPageGroupWholesale.pages.push(
                {
                    title: 'Shortlist',
                    url: '/wholesale/shortlist',
                    iconalt: 'icon-mc-favourite',
                    count: 'WholesaleCounts/Vehicles/Shortlist'
                }
            );
            appPageGroupWholesale.pages.push(
                {
                    title: 'My offers',
                    url: '/wholesale/buying/offers/redirect',
                    iconalt: 'icon-mc-sales'
                }
            );
            appPageGroupWholesale.pages.push(
                {
                    title: 'Pending',
                    url: '/wholesale/buying/offers/pending',
                    icon: '', //timer-outline',
                    child: true,
                    count: 'WholesaleCounts/Offers/Outgoing/PendingAcceptance'
                }
            );
            appPageGroupWholesale.pages.push(
                {
                    title: 'Accepted',
                    url: '/wholesale/buying/offers/won',
                    icon: '', //thumbs-up-outline',
                    child: true,
                    count: 'WholesaleCounts/Offers/Outgoing/SellerAccepted'
                }
            );
            appPageGroupWholesale.pages.push(
                {
                    title: 'Declined',
                    url: '/wholesale/buying/offers/lost',
                    icon: '', //thumbs-down-outline',
                    child: true,
                    count: 'WholesaleCounts/Offers/Outgoing/SellerRejected'
                }
            );
            // appPageGroupWholesale.pages.push(
            // 	{
            // 		title: 'Accepted',
            // 		url: '/wholesale/buying/offers/won',
            // 		icon: 'thumbs-up-outline',
            // 		iconalt: 'icon-gavel'
            // 	}
            // );
            // appPageGroupWholesale.pages.push(
            // 	{
            // 		title: 'Declined',
            // 		url: '/wholesale/buying/offers/lost',
            // 		icon: 'thumbs-down-outline'
            // 	}
            // );
            // appPageGroupWholesale.pages.push(
            // 	{
            // 		title: 'Suppliers',
            // 		url: '/wholesale/suppliers',
            // 		icon: 'star-outline',
            // 		iconalt: 'icon-contacts'
            // 	}
            // );
            appPageGroups.push(appPageGroupWholesale);
        }

        if (this.hasRight(extendedRights, SecurityRight.ToolsDealerzoneWholesale) &&
            this.hasRight(rights, SecurityRight.ToolsDealerzoneWholesale))
        {
            var appPageGroupWholesale2: AppPageGroupModel =
            {
                area: "wholesale",
                name: "Sell",
                pages: []
            };
            appPageGroupWholesale2.pages.push(
                {
                    title: 'My vehicles',
                    url: '/wholesale/selling/vehicles',
                    iconalt: 'icon-mc-vehicle',
                    child: false,
                    count: 'WholesaleCounts/Vehicles/Selling'
                }
            );
            appPageGroupWholesale2.pages.push(
                {
                    title: 'Offers received',
                    url: '/wholesale/selling/offers/redirect',
                    iconalt: 'icon-mc-offers-received'
                }
            );
            appPageGroupWholesale2.pages.push(
                {
                    title: 'Pending',
                    url: '/wholesale/selling/offers/pending',
                    icon: '', //timer-outline',
                    child: true,
                    count: 'WholesaleCounts/Offers/Incoming/PendingAcceptance'
                }
            );
            appPageGroupWholesale2.pages.push(
                {
                    title: 'Accepted',
                    url: '/wholesale/selling/offers/complete',
                    icon: '', //thumbs-up-outline',
                    child: true,
                    count: 'WholesaleCounts/Offers/Incoming/SellerAccepted'
                }
            );
            // appPageGroupWholesale2.pages.push(
            // 	{
            // 		title: 'Declined',
            // 		url: '/wholesale/selling/offers/rejected',
            // 		icon: '', //thumbs-down-outline',
            // 		child:true,
            // 		count: 'WholesaleCounts/Offers/Incoming/SellerRejected'
            // 	}
            // );
            appPageGroupWholesale2.pages.push(
                {
                    title: 'Questions',
                    url: '/wholesale/selling/questions',
                    iconalt: 'icon-mc-questions',
                    count: 'WholesaleCounts/UnansweredQuestions'
                }
            );
            appPageGroups.push(appPageGroupWholesale2);
        }


        var appPageGroupFC: AppPageGroupModel =
        {
            area: 'financecentral',
            name: "Avanti Finance",
            pages: []
        };
        appPageGroupFC.pages.push(
            {
                title: 'Create application',
                url: '/finance/application',
                iconalt: 'icon-mc-application',
            }
        );
        // appPageGroupFC.pages.push(
        // 	{
        // 		title: 'Dealer portal',
        // 		url: '/finance-central/portal',
        // 		icon: 'play',
        // 	}
        // );
        appPageGroups.push(appPageGroupFC);


        if (this.hasRight(rights, SecurityRight.AdminWebsiteMan))
        {
            var appPageGroupWebsiteAdmin: AppPageGroupModel =
            {
                area: 'website-admin',
                name: "",
                pages: []
            };

            appPageGroups.push(appPageGroupWebsiteAdmin);
        }

        return appPageGroups;

    }

    hasRight(userRights: SecurityRight[], rightToCheck: SecurityRight): boolean
    {
        if (userRights)
        {
            let check = userRights.filter(x => x == rightToCheck);
            return check.length > 0;
        }
        else
        {
            return false;
        }
    }

    getContactColorClass(name: string = ''): string
    {
        let initial = '';
        let className = '';
        let checkName = name ? (name) : '';

        if (checkName.length > 0)
        {
            initial = checkName[0].toLowerCase();
        }

        if (!(/^[a-z]$/.test(initial)))
        {
            initial = '';
        }

        if (initial === '')
        {
            initial = '0';
        }

        return 'contactbadge contact-class-' + initial;
    }

    currentMCVersion: string;
    mcMinVersion(version: string, ignoreCache: boolean = false): boolean
    {
        if (!this.currentMCVersion || ignoreCache == true)
        {
            this.currentMCVersion = localStorage.getItem(Constants.LocalStorage_MCDesktopVersion);
        }
        // console.log(`mcMinVersion(${version}); current version = `, this.currentMCVersion);
        var versionCompare = this.version_compare(this.currentMCVersion, version, '>=');
        return versionCompare;
    }

    version_compare(v1, v2, operator): any
    {
        return StringHelper.versionCompare(v1, v2, operator);
    }


    public countMessage = new Subject<CountMessage>();
    public doCountMessage(endpoint: CountMessageEndpointType, count: number)
    {
        this.countMessage.next(
            {
                endpoint: endpoint,
                count: count
            }
        );
    }

    public doCountMessages(counts: WholesaleCountsModel)
    {
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Vehicles/All',
                count: counts.vehiclesAll
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Vehicles/Recommended',
                count: counts.recommendations
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Vehicles/Shortlist',
                count: counts.shortlist
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Offers/Outgoing/PendingAcceptance',
                count: counts.outgoingOffersPending
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Offers/Outgoing/SellerAccepted',
                count: counts.outgoingOffersAccepted
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Offers/Outgoing/SellerRejected',
                count: counts.outgoingOffersRejected
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Vehicles/Selling',
                count: counts.vehiclesSelling
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Offers/Incoming/PendingAcceptance',
                count: counts.incomingOffersPending
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Offers/Incoming/SellerAccepted',
                count: counts.incomingOffersAccepted
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/Offers/Incoming/SellerRejected',
                count: counts.incomingOffersRejected
            }
        );
        this.countMessage.next(
            {
                endpoint: 'WholesaleCounts/UnansweredQuestions',
                count: counts.unansweredQuestions
            }
        );
    }

    public setEmbedded(embedded: boolean = false)
    {
        this.embeddedSubject.next(embedded);
    }

    public getDefaultStartupAppList(): ListItemModel[] {
        const list: ListItemModel[] = [];
        list.push(new ListItemModel(AppHeaderEnum.MotorcentralDms, "Motorcentral DMS"));
        list.push(new ListItemModel(AppHeaderEnum.VehicleXchange, "VehicleXchange"));
        list.push(new ListItemModel(AppHeaderEnum.AvantiFinance, "Avanti Finance"));
        list.push(new ListItemModel(AppHeaderEnum.CarCheck, "Car Check"));
        list.push(new ListItemModel(AppHeaderEnum.BuyerScore, "BuyerScore"));
        list.push(new ListItemModel(AppHeaderEnum.AutoAttendant, "Auto Attendant"));
        if (this.mcMinVersion("3.2.21")) 
        {
            list.push(new ListItemModel(AppHeaderEnum.WebsiteAdmin, "Website Admin"));
        }
        return list;
    }

    public getDefaultDmsStartupPageList(): ListItemModel[] {
        const list: ListItemModel[] = [];
        list.push(new ListItemModel(DmsPageHeaderEnum.Dashboard, "Dashboard"));
        list.push(new ListItemModel(DmsPageHeaderEnum.Vehicles, "Vehicles"));
        list.push(new ListItemModel(DmsPageHeaderEnum.Contacts, "Contacts"));
        list.push(new ListItemModel(DmsPageHeaderEnum.Sales, "Sales"));
        list.push(new ListItemModel(DmsPageHeaderEnum.Opportunities, "Opportunities"));
        list.push(new ListItemModel(DmsPageHeaderEnum.Exports, "Exports"));
        list.push(new ListItemModel(DmsPageHeaderEnum.Reports, "Reports"));
        if (this.mcMinVersion("3.2.21")) 
        {
            list.push(new ListItemModel(DmsPageHeaderEnum.Tasks, "Tasks"));
            list.push(new ListItemModel(DmsPageHeaderEnum.Documents, "Documents"));
        }
        if (this.mcMinVersion("3.2.22"))
        {
            list.push(new ListItemModel(DmsPageHeaderEnum.MoneyOutstanding, "Money Outstanding"));
            list.push(new ListItemModel(DmsPageHeaderEnum.SystemEvents, "System Events"));
        }
        return list;
    }

    public getDefaultWebsiteAdminStartupPageList(): ListItemModel[] {
        const list: ListItemModel[] = [];
        list.push(new ListItemModel(WebsiteAdminPageHeaderEnum.Vehicles, "Vehicles"));
        list.push(new ListItemModel(WebsiteAdminPageHeaderEnum.Dealerships, "Dealerships"));
        list.push(new ListItemModel(WebsiteAdminPageHeaderEnum.Products, "Products"));
        list.push(new ListItemModel(WebsiteAdminPageHeaderEnum.Blog, "Blog"));
        list.push(new ListItemModel(WebsiteAdminPageHeaderEnum.Testimonials, "Testimonials"));
        return list;
    }

    public getDefaultVehicleXchangeStartupPageList(): ListItemModel[] {
        const list: ListItemModel[] = [];
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.Browse, "Browse"));
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.Suggested, "Suggested"));
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.Shortlist, "Shortlist"));
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.PendingBuyOffers, "Pending Buy Offers"));
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.AcceptedBuyOffers, "Accepted Buy Offers"));
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.DeclinedBuyOffers, "Declined Buy Offers"));
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.MyVehicles, "My Vehicles"));
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.PendingSellOffers, "Pending Sell Offers"));
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.AcceptedSellOffers, "Accepted Sell Offers"));
        list.push(new ListItemModel(VehicleXchangePageHeaderEnum.Questions, "Questions"));
        return list;
    }

    public getDefaultCarCheckStartupPageList(): ListItemModel[] {
        const list: ListItemModel[] = [];
        list.push(new ListItemModel(CarCheckPageHeaderEnum.RecentChecks, "Recent Checks"));
        list.push(new ListItemModel(CarCheckPageHeaderEnum.Search, "Search"));
        return list;
    }

    async getRootPath(area: string): Promise<string> 
    {
        let rootPath = area;
        switch (area) {
            case "dms":
                rootPath = "dms/splash";
                break;
            case "website-admin":
                rootPath = "website-admin/splash";
                break;
            case "wholesale":
                rootPath = "wholesale/splash";
                break;
            case "carcheck":
                rootPath = "carcheck/splash";
                break;
            case "buyerscore":
                rootPath = "buyerscore";
                break;
            case "autoattendant":
                rootPath = "autoattendant";
                break;
            case "finance":
                rootPath = "finance";
                break;
            default:
                rootPath = "dms/splash";
                break;
        }
        return rootPath;
    }
}

export interface CountMessage
{
    endpoint: CountMessageEndpointType;
    count: number;
}
